import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WhyCYJWorks = () => (
  <Box sx={{ bgcolor: 'custom.beige', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white', maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        Why CYJ Works (and why it feels different)
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 2, textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        CYJ is built from:
      </Typography>
      <Box sx={{ maxWidth: 600, mx: 'auto', mb: 2 }}>
        <ul style={{ color: '#555', fontSize: '1.05rem', margin: 0, paddingLeft: 24 }}>
          <li>Positive Psychology research</li>
          <li>real-life transformation work</li>
          <li>and years of creating tools that actually work when life feels heavy</li>
        </ul>
      </Box>
      <Typography sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
        It’s deep, but not overwhelming.<br/>
        Structured, but still emotional and human.<br/>
        Gentle, but powerful.
      </Typography>
    </Paper>
  </Box>
);

export default WhyCYJWorks;
